import { render, staticRenderFns } from "./FittingAnswerView.vue?vue&type=template&id=5401f4d2"
import script from "./FittingAnswerView.vue?vue&type=script&lang=js"
export * from "./FittingAnswerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports